const data = {
  respuesta: [
    {
      formaPago: '02', 
      nombreCuenta: 'Cuenta test',
      IBAN: 'FG45 6589 2256 3211 1236',
      resto: 'OPDFGY11',
      fecha: '2023-02-25',
      idCliente: 1 
    },
    {
      formaPago: '12', 
      nombreCuenta: 'Nombre test',
      IBAN: 'JK56 5214 1125 3002 2156 00',
      resto: 'DPPCHJ25',
      fecha: '2024-10-09',
      idCliente: 1 
    },
    {
      formaPago: '19', 
      nombreCuenta: 'Cuenta 1234',
      IBAN: 'GH45 1255 6638 0985 9652 0112',
      resto: 'SERAMNOP589',
      fecha: '2021-07-12',
      idCliente: 1 
    },
  ],
  meta: {
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 1
  },
  blnError: false,
  codError: null,
  msgError: null
}

export default data
